import React, { useEffect } from 'react';
import { useNotification } from '../../contexts/NotificationContext';
import { setNotificationContext } from '../../utils/notifications';

const Index = ({ children }) => {
  const notificationContext = useNotification();

  useEffect(() => {
    setNotificationContext(notificationContext);
  }, [notificationContext]);

  return children;
};

export default Index;
